import React, { useEffect } from "react";
import { Redirect, Route, Switch, useParams } from "react-router-dom";
import useQueryParams from "hooks/use-query-params";
import { useQuery } from "react-query";

import useCurrentUser from "hooks/use-current-user";
import CurrentUserRepository from "lib/repository/current-user-repository";
import Loader from "components/common/loader/loader";

import AudioProfile from "components/pages/audio-profile/audio-profile";
import { isDefined } from "helpers/predicates";

const UserRouteController = ({ match }) => {
  const params = useParams();
  const uuid = useQueryParams("uuid");
  const { setUserPermissions } = useCurrentUser();

  const userPermissionsParams = { ...params, uuid };

  const { isLoading, data: permissions } = useQuery(
    ["user", userPermissionsParams],
    () => CurrentUserRepository.getCurrentUserPermissions(userPermissionsParams)
  );

  useEffect(() => {
    if (!isLoading && isDefined(permissions)) {
      setUserPermissions(permissions);
    }
  }, [params, uuid, setUserPermissions, permissions, isLoading]);

  if (isLoading) {
    return <Loader position={"absolute"} />;
  }

  return (
    <Switch>
      <Route path={`${match.url}`} component={AudioProfile} />
      <Redirect from={`${match.url}/*`} to="/error" />
    </Switch>
  );
};

export default UserRouteController;
